export const articles = [
  {
    slug: "anorexia-statistics",
    image: "/images/depressed-cyprus-anorexia-1200x800.jpg",
    imageDetails: "/images/depressed-cyprus-anorexia-600x400.jpg",
    titleKey: "articles.article1.title",
    metaKey: "articles.article1.meta",
    contentTitleKey: "articles.article1.contentTitle",
    contentKey: "articles.article1.content",
    tagsKey: "articles.article1.tags",
  },
  {
    slug: "working-from-home",
    image: "/images/working-from-home.jpg",
    imageDetails: "/images/working-from-home-details.jpg",
    titleKey: "articles.article2.title",
    metaKey: "articles.article2.meta",
    contentTitleKey: "articles.article2.contentTitle",
    contentKey: "articles.article2.content",
    tagsKey: "articles.article2.tags",
  },
  {
    slug: "psychotic_disorders",
    image: "/images/psychotic-disorders.jpg",
    imageDetails: "/images/psychotic-disorders.jpg",
    titleKey: "articles.article3.title",
    metaKey: "articles.article3.meta",
    contentTitleKey: "articles.article3.contentTitle",
    contentKey: "articles.article3.content",
    tagsKey: "articles.article3.tags",
  },
  {
    slug: "body-appreciation-gratitude",
    image: "/images/body-appreciation-gratitude-1200x801.jpg",
    imageDetails: "/images/body-appreciation-gratitude-600x400.jpg",
    titleKey: "articles.article4.title",
    metaKey: "articles.article4.meta",
    contentTitleKey: "articles.article4.contentTitle",
    contentKey: "articles.article4.content",
    tagsKey: "articles.article4.tags",
  },
  {
    slug: "lazyness",
    image: "/images/lazy.png",
    imageDetails: "/images/lazy-details.png",
    titleKey: "articles.article5.title",
    metaKey: "articles.article5.meta",
    contentTitleKey: "articles.article5.contentTitle",
    contentKey: "articles.article5.content",
    tagsKey: "articles.article5.tags",
  },
  {
    slug: "helplessness",
    image: "/images/helplessness-details.jpg",
    imageDetails: "/images/helplessness.jpg",
    titleKey: "articles.article6.title",
    metaKey: "articles.article6.meta",
    contentTitleKey: "articles.article6.contentTitle",
    contentKey: "articles.article6.content",
    tagsKey: "articles.article6.tags",
  },
  {
    slug: "success-secret",
    image: "/images/success-tips-details.jpeg",
    imageDetails: "/images/success-tips.jpeg",
    titleKey: "articles.article7.title",
    metaKey: "articles.article7.meta",
    contentTitleKey: "articles.article7.contentTitle",
    contentKey: "articles.article7.content",
    tagsKey: "articles.article7.tags",
  },
  {
    slug: "children-domestic-violence",
    image: "/images/victim.jpg",
    imageDetails: "/images/victim.jpg",
    titleKey: "articles.article8.title",
    metaKey: "articles.article8.meta",
    contentTitleKey: "articles.article8.contentTitle",
    contentKey: "articles.article8.content",
    tagsKey: "articles.article8.tags",
  },
];
